import type { Theme } from '@mui/material';

export const styles = {
  paper: (theme: Theme) => ({
    h6: {
      color: `${theme.colors.black} !important`, // change when dialog override is fixed
    },
    h4: {
      color: `${theme.colors.black} !important`, // change when dialog override is fixed
    },
    color: `${theme.colors.black} !important`, // change when dialog override is fixed
    px: '0 !important', // change when dialog override is fixed
    py: '1.5rem !important', // change when dialog override is fixed
    width: '26rem',
  }),

  closeButton: (theme: Theme) => ({
    color: theme.colors.primary[600],
    p: 0,
  }),

  label: {
    height: '20px',
  },
};
